import { TMenuStoreState } from './types';

export function getMenu(state: TMenuStoreState) {
  return state.menu;
}
